export default __webpack_public_path__ + "static/media/9-1.cb832b7e.png";